import { Grid, TextField, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { useStyle } from "../style";
import axios from "axios";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import moment from "moment";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";

const PurchaseInfo = ({setPostData , postData , poDetails , setPoDetails,data}) => {
  const classes = useStyle();
  const [docName , setDocName] = useState("")
  const dispatch = useDispatch()
  // const [poDetails , setPoDetails] = useState({
  //   docDate:moment().format(),
  // })
  const outlet_id = localStorage.getItem("outlet_id");

  const handleChange =(e, name) => {
    if(name==='docDate' ){
      setPoDetails((prevState) =>( {...prevState ,  [name] : dayjs(e).format() }))
    }else{
      setPoDetails((prevState) =>( {...prevState , [name] :  e}))
    }
      
  }
  const getPurchaseData = () => {
    axios.get(`/v1/wastage/outlet/docno/${outlet_id}`)
    // axios.get(`/v1/wastage/fetch/docno`)
    .then((res) => {
      setDocName(res.data.Docno)
    })
    .catch((err) => {
      console.log(err)
      dispatch(setSnackbar(true,'error',err.response.data.error))
    })
  }
  useEffect(() => {
    getPurchaseData() // purchase doc name
  },[])
  useEffect(() => {
    if (data.length > 0) {
      // Extract uid values from data array
      const uidValue = data.length === 1 ? data[0].uom : null;


      // Update the postData state with the new values
      setPostData((prevState) => ({
        ...prevState,
        date: moment(poDetails.docDate).format('YYYY-MM-DD'),
        company_id: 1,
        uid: uidValue,
        outlet_id: outlet_id,
      }));
    }
  }, [data, poDetails, outlet_id]);
//   useEffect(() => {
// setPostData((prevState) => ({...prevState , date:moment(poDetails.docDate).format('YYYY-MM-DD'),company_id:1,uid:data.uom,outlet_id:outlet_id}))
//   },[poDetails])
  console.log(postData,"poDetails");
  
  return (
    <Grid container spacing={2} className="p-2 h-full" >
         <Grid item lg={4} >
         <TextField size="small" label='Bill No' fullWidth value={docName} />
         <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker  onChange={(e)=>handleChange(e,'docDate')} value={dayjs(poDetails.docDate)} label="Bill Date" slotProps={{
                  textField: {
                    size: "small",
                  },
                  }}
                  sx={{width: '100%',marginBlock:1.5}}
            />
          </LocalizationProvider>
         </Grid>
        <Grid item lg={4}>
        
       
        </Grid>
      <Grid item lg={4}>
        <Typography textAlign="center" variant="h6" sx={{backgroundColor:'#83A2FF',}}>Balance</Typography>
        <Typography textAlign='right' variant="h5" mt={1} sx={{fontWeight:600,}}>0.00</Typography>
      </Grid>
    </Grid>
  );
};

export default memo(PurchaseInfo);
